import React from 'react';
import styled from 'styled-components';
import {
  Gray1,
  ToolbarBackground,
  ToolbarFontColor,
} from '../../common/colors';
import { AnnotationViewerPageControls } from '../containers/annotation-viewer-page-controls.container';
import { ConnectedPageFilterButton } from '../containers/page-filter-button.container';
import { ConnectedVersionHistoryToolbar } from '../containers/version-history-toolbar.container';
import { Flag } from '../../flags';

const ControlBarWrapper = styled.div`
  background-color: ${ToolbarBackground};
  color: ${ToolbarFontColor};
  border-bottom: 1px solid ${Gray1};
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  max-height: 44px;

  .ant-btn-group {
    height: 100%;

    button {
      height: 100%;
      border: 1px solid white;
    }

    button.ant-btn:first-child:not(:last-child),
    button.ant-btn:last-child:not(:first-child) {
      border-radius: 0px;
    }
  }
`;

const Left = styled.div`
  text-align: left;
  flex: 0 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  height: 40px;
`;

const Center = styled.div`
  text-align: center;
  flex: 1 1 auto;
  padding: 4px 0;
`;

const Right = styled.div`
  flex: 0 0 auto;
  text-align: right;

  .content {
    text-align: left;
    display: inline-block;
  }
`;

export class AnnotationViewerControls extends React.PureComponent {
  render() {
    return (
      <ControlBarWrapper>
        <Left>
          <ConnectedPageFilterButton />
          <Flag name={['features', 'diffViewer']}>
            <ConnectedVersionHistoryToolbar />
          </Flag>
        </Left>
        <Center>
          <AnnotationViewerPageControls />
        </Center>
        <Right />
      </ControlBarWrapper>
    );
  }
}
